import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Actions, CAMPAIGN_SYNC_STATE, IActiveTab, IEditNameCellRenderer } from "@ts/common-types";
import { updateCampaigns, updateAdGroups, updatePortfolios, isDisabledUI } from "@ts/utils";
import $ from "jquery";
import { showToast } from "@ts/modals";
import { useGetModulesData, usePermissionCheck } from "@hooks/AllCustomHooks";
import { FaPencil } from "react-icons/fa6";
import { FaCheck, FaTimes } from "react-icons/fa";
import { setUpdateGridData } from "@/ts/filters";


const EditNameCellRenderer: React.FC<IEditNameCellRenderer> = ({ params, setInputWidth, setInputValue, isCampaignSyncCheckRequired }) => {
    const actions = useGetModulesData({ type: "actions" });
    const { isModuleEditDisabled } = usePermissionCheck({ type: "cellRenderer" });
    const actionStatus = !actions.includes(Actions.NAME_CHANGE);
    const [isUIDisabled, setIsUIDisabled] = useState<boolean>(false);
    const [identifier, setIdentifier] = useState<string>();
    const [previousValue, setPreviousValue] = useState<string>();
    const [spinnerDisp, setSpinnerDisp] = useState<string>("none");
    const [applyEditDivDisp, setApplyEditDivDisp] = useState<string>("none");
    const [inputClass, setInputClass] = useState<string>(
        "input-group input-group-sm"
    );
    const [editButtonDisp, setEditButtonDisp] = useState<string>("flex");
    const activeTab = useSelector((state: IActiveTab) => state.activeTab.value);

    isCampaignSyncCheckRequired

    const getEditActionsWidth = () => {
        const totalContainerWidth = $(
            `#${identifier}-edit-container`
        ).outerWidth();
        const actionBtnsWidth = $(`#${identifier}-edit-div`).outerWidth();
        return totalContainerWidth - actionBtnsWidth - 35;
    };

    const editButtonClickHandler = () => {
        setInputWidth(getEditActionsWidth());
        const nameElementId = identifier;
        const nameUpdateElementId = `${nameElementId}-update-field`;

        $(`#${nameElementId}`).hide();
        $(`#${nameUpdateElementId}`).val(previousValue);
        $(`#${nameUpdateElementId}`).show();

        setEditButtonDisp("none");
        setApplyEditDivDisp("flex");
    };

    const applyButtonClickHandler = async () => {
        const nameElementId = identifier;
        const nameUpdateElementId = `${nameElementId}-update-field`;
        const nameDivToUpdateId = `${identifier}-name`;
        const updatedName = $(`#${nameUpdateElementId}`).val() as string;

        if (updatedName === previousValue) {
            showToast("danger", "Please update the value.");
            return;
        }

        const updateGridConfig = {
            params,
            value: updatedName,
            isReduxState: true,
        };

        if (updatedName.length) {
            setApplyEditDivDisp("none");
            setSpinnerDisp("unset");
            setInputClass("");

            let response;
            switch (activeTab) {
                case "campaigns":
                    try {
                        response = await updateCampaigns([
                            {
                                campaignId:
                                    params.data.sys_campaign_id.toString(),
                                campaign_name: updatedName,
                                attribute: ["campaign_name"],
                                state: params.data.state || "enabled",
                            },
                        ]);

                        if (!response.status) {
                            throw new Error(response.message);
                        }

                        setUpdateGridData(updateGridConfig);
                        showToast(
                            "success",
                            `Name updated for campaign : ${previousValue}`
                        );

                        setPreviousValue(updatedName);
                    } catch (e) {
                        $(`#${nameDivToUpdateId}`).text(previousValue);
                        showToast(
                            "danger",
                            `Error while updating name for campaign : ${previousValue} : ${(e as Error).message
                            }`
                        );
                    }

                    break;

                case "adgroups":
                    try {
                        response = await updateAdGroups([
                            {
                                adgroupId:
                                    params.data.sys_adgroup_id.toString(),
                                adgroupName: updatedName,
                                attribute: ["ad_group_name"],
                                state: params.data.state || "enabled",
                            },
                        ]);

                        if (!response.status) {
                            throw new Error(response.message);
                        }

                        setUpdateGridData(updateGridConfig);

                        showToast(
                            "success",
                            `Name updated for adgroup : ${previousValue}`
                        );

                        setPreviousValue(updatedName);
                    } catch (e) {
                        $(`#${nameDivToUpdateId}`).text(previousValue);
                        showToast(
                            "danger",
                            `Error while updating name for adgroup :  ${previousValue} : ${(e as Error).message
                            }`
                        );
                    }
                    break;

                case "portfolios":
                    try {
                        response = await updatePortfolios([
                            {
                                portfolioId:
                                    params.data.portfolio_id.toString(),
                                attribute: ["portfolio_name"],
                                portfolio_name: updatedName,
                                state: params.data.state || "enabled",
                            },
                        ]);

                        if (!response.status) {
                            throw new Error(response.message);
                        }

                        setUpdateGridData(updateGridConfig);

                        showToast(
                            "success",
                            `Name updated for portfolio : ${previousValue}`
                        );

                        setPreviousValue(updatedName);
                    } catch (e) {
                        $(`#${nameDivToUpdateId}`).text(previousValue);
                        showToast(
                            "danger",
                            `Error While Updating Name for portfolio :  ${previousValue} : ${(e as Error).message
                            }`
                        );
                    }
                    break;
            }

            $(`#${nameElementId}`).show();
            $(`#${nameUpdateElementId}`).hide();

            setInputClass("input-group input-group-sm");
            setEditButtonDisp("flex");
            setSpinnerDisp("none");
            setApplyEditDivDisp("none");
        } else {
            showToast("danger", "Name length should be greater than 1");
        }
    };

    const cancelButtonClickHandler = async () => {
        setInputValue(previousValue);
        const nameElementId = identifier;
        const nameUpdateElementId = `${nameElementId}-update-field`;

        $(`#${nameElementId}`).show();
        $(`#${nameUpdateElementId}`).hide();

        setEditButtonDisp("flex");
        setApplyEditDivDisp("none");
    };

    const actionBtnCss = {
        border: "1px solid #B2B2B2",
        borderRadius: "6px",
    };

    useEffect(() => {
        switch (activeTab) {
            case "campaigns":
                let disabledState = isModuleEditDisabled ||
                    !params.data.sys_campaign_id ||
                    actionStatus ||
                    isDisabledUI([params.data.campaign_status]);
                if (isCampaignSyncCheckRequired) {
                    const isPending = params.data.sync_state === CAMPAIGN_SYNC_STATE.PENDING;
                    disabledState = isPending || !!disabledState;
                }
                setIsUIDisabled(
                    disabledState
                );
                setIdentifier(
                    `${params.data.sys_campaign_id}-${params.data.program_type}`
                );
                setPreviousValue(params.data.campaign_name);
                break;

            case "adgroups":
                setIsUIDisabled(
                    (isModuleEditDisabled || !params.data.sys_adgroup_id ||
                        params.data.program_type === "sb" ||
                        params.data.program_type === "hsa") ||
                    actionStatus
                );
                setIdentifier(
                    `${params.data.sys_adgroup_id}-${params.data.program_type}`
                );
                setPreviousValue(params.data.ad_group_name);
                break;

            case "portfolios":
                setIsUIDisabled(isModuleEditDisabled || !params.data.portfolio_id || actionStatus);
                setIdentifier(`${params.data.portfolio_id}`);
                setPreviousValue(params.data.portfolio_name);
                break;
        }
    }, [activeTab, params.data, actions, actionStatus, isModuleEditDisabled]);
    return (
        <>
            <div className="ag-cell-wrapper">
                <div className={`${inputClass} ${actionStatus ? 'd-none' : ''}`} >
                    <button className="btn-sm btn-light p-2"
                        id={`${identifier}-edit-btn`}
                        disabled={isUIDisabled}
                        onClick={editButtonClickHandler}
                        style={{
                            display: `${editButtonDisp}`,
                            ...actionBtnCss,
                            alignItems: "center",
                        }}>
                        <FaPencil style={{ fontSize: "12px", color: `${isModuleEditDisabled ? "grey" : ""}` }} />
                    </button>
                    <div
                        id={`${identifier}-edit-div`}
                        style={{
                            display: `${applyEditDivDisp}`,
                        }}
                    >
                        <button
                            id={`${identifier}-apply-edit-btn`}
                            className="btn-sm btn-light mx-1 p-2"
                            onClick={applyButtonClickHandler}
                            style={{
                                padding: "4px 8px",
                                ...actionBtnCss,
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <FaCheck className="text-primary" style={{ fontSize: "15px" }} />
                        </button>

                        <button
                            className="btn-sm btn-light p-2"
                            onClick={cancelButtonClickHandler}
                            style={{
                                padding: "4px 9px",
                                ...actionBtnCss,
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <FaTimes style={{ fontSize: "15px" }} />
                        </button>
                    </div>
                    <button
                        className="spinner-border text-primary"
                        style={{ display: `${spinnerDisp}` }}
                    ></button>
                </div>
            </div>
        </>
    );
};

export default EditNameCellRenderer;
